import { createApi } from '@reduxjs/toolkit/query/react';
import { client } from '../../../api/NestClient';
import { nestBaseQuery } from '../../../utils/nestBaseQuery';

/**
 * ✅ Updated Status API Response (override OpenAPI type safely)
 */
export interface GetMaintenanceStatusResponse {
  is_enabled?: boolean;
  message?: string;
  reason?: string | null;
  starts_at?: string | null;
  ends_at?: string | null;
}

/**
 * ✅ SSE Event Payload
 */
export interface MaintenanceEventPayload {
  type?: string;
  scope?: string;
  is_enabled?: boolean;
  message?: string;
  reason?: string | null;
  starts_at?: string | null;
  ends_at?: string | null;
  timestamp?: string;
}

export const maintenanceApi = createApi({
  reducerPath: 'maintenanceApi',
  baseQuery: nestBaseQuery,
  tagTypes: ['Maintenance'],

  endpoints: (builder) => ({
    getMaintenanceStatus: builder.query<GetMaintenanceStatusResponse, void>({
      query: () => {
        return (client as any).GET('/api/v1/maintenance/status', {
          params: {
            query: {
              scope: 'global',
            },
          },
        });
      },
      providesTags: ['Maintenance'],
    }),
  }),
});

export const { useGetMaintenanceStatusQuery } = maintenanceApi;

/**
 * ✅ SSE Listener (real-time updates)
 */
export const createMaintenanceEventSource = (
  onMessage: (data: MaintenanceEventPayload) => void,
  onError?: (error: Event) => void
): EventSource => {
  const backendUrl = process.env.REACT_APP_API_URL || 'https://api.dev.ledgerx365.com';

  const eventSource = new EventSource(
    `${backendUrl}/api/v1/maintenance/events?scope=global`
  );

  eventSource.onmessage = (event) => {
    try {
      const parsed = JSON.parse(event.data) as MaintenanceEventPayload;
      onMessage(parsed);
    } catch (err) {
      console.error('[Maintenance SSE] Invalid payload:', err);
    }
  };

  eventSource.onerror = (error) => {
    if (onError) onError(error);
  };

  return eventSource;
};
